import type { PokerHomeGames } from '@ps/web-martech-cms-types';
import type {
  ClubIdRequest,
  ClubSeason,
  ClubSeasonsResponse
} from '@ps/web-shared-api-types/v1-preview/SwHomeGames';
import { last } from 'lodash';

import type { ExtractDispatchFromModel, WidgetEffectParams } from '@swf/core/store';

import { PKR_LOADERS } from '../../constants';
import { ENDPOINTS } from '../../constants/endpoints';
import type { HomeGamesWidgetModel } from '../../model';

export const fetchClubSeasons = async (
  { clubId, latestOnly }: { clubId: string; latestOnly?: boolean },
  { request, dispatch, widget: { uid } }: WidgetEffectParams<PokerHomeGames>
) => {
  const widgetDispatch: ExtractDispatchFromModel<HomeGamesWidgetModel> = dispatch[uid];
  const loaderName = PKR_LOADERS.clubSeasons;
  widgetDispatch.setLoading({ isLoading: true, loaderName });

  try {
    const { body } = await request<ClubSeasonsResponse>({
      service: ENDPOINTS.clubSeason,
      body: { clubId: Number(clubId) } as ClubIdRequest,
      http: true
    });
    const seasons = body?.seasonsReply?.seasons;

    if (latestOnly && seasons?.length) {
      widgetDispatch.setClubSeasons({ clubId, seasons: [last(seasons) as ClubSeason] });
    } else if (!latestOnly && seasons && seasons.length) {
      widgetDispatch.setClubSeasons({ clubId, seasons });
    } else if (!seasons || !seasons?.length) {
      widgetDispatch.setLoading({ isLoading: false, loaderName: PKR_LOADERS.clubSeasonStats });
    }
  } catch (error) {
    widgetDispatch.setLoading({ isLoading: false, loaderName });
  } finally {
    widgetDispatch.setLoading({ isLoading: false, loaderName });
  }
};
